import confetti from 'canvas-confetti';

// Brand colors from https://brand.customer.io/docs/color
export const BRAND_VERDANT = '#E4FFCE';
export const BRAND_EVERGREEN = '#0B353B';

export function fireConfetti(element: HTMLElement | null, options: confetti.Options = {}) {
  if (element == null) {
    return;
  }
  const bounds = element.getBoundingClientRect();
  confetti({
    startVelocity: 30,
    disableForReducedMotion: true,
    colors: [BRAND_VERDANT, BRAND_EVERGREEN],
    scalar: 0.6,
    ...options,
    origin: {
      x: (bounds.left + bounds.width / 2) / window.innerWidth,
      y: (bounds.top + bounds.height / 2) / window.innerHeight,
    },
  });
}
